export default "__VITE_ASSET__BRG3joJH__"